import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API from '../../services/api.ts';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import styles from './Login.module.css';
import { Link, useNavigate, useParams } from 'react-router-dom';

const ResetPassword = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error('Passwords do not match.');
      return;
    }
    if (password.length < 8) {
      toast.error('Password must be at least 8 characters.');
      return;
    }

    try {
      setSubmitting(true);
      await API.post('/accounts/password-reset/confirm/', {
        uid,
        token,
        new_password: password,
      });
      setDone(true);
      toast.success('Password reset successful. You can now log in.');
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      const data = err?.response?.data;
      const msg =
        data?.detail ||
        data?.new_password?.[0] ||
        'Could not reset password. The link may be invalid or expired.';
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={`${styles.login} d-flex flex-column align-items-center justify-content-center`}>
      <Link to="/login" className="position-absolute top-0 start-0 m-3 btn btn-outline-secondary btn-sm">
        <i className="fa fa-arrow-left me-1"></i> Back to login
      </Link>

      <ToastContainer autoClose={3000} />

      <div className="d-flex align-items-center justify-content-center gap-4 mb-4">
        <div className={`${styles.bgImage1}`}>
          <img src="/assets/MountSinaiLogo.png" alt="logo" className="img-fluid" />
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-4 col-lg-6 mx-auto">
            <div className="row">
              <div className="col text-start">
                <h3 className={`${styles.loginHeading} mb-2`}>Set a new password</h3>
                <p className="text-muted mb-4">
                  Choose a new password for your account. Use at least 8 characters.
                </p>
              </div>
            </div>

            {done ? (
              <div className="alert alert-success" role="alert">
                <i className="fa fa-check-circle me-2"></i>
                Your password has been reset. Redirecting to login...
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="was-validated" noValidate>
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text" id={styles.inputGroupText}>
                      <i className="fa fa-key"></i>
                    </span>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="form-control"
                      placeholder="New password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      minLength={8}
                      required
                    />
                    <span
                      className="input-group-text"
                      id={styles.eye}
                      style={{ cursor: 'pointer' }}
                      onClick={() => setShowPassword((s) => !s)}
                      aria-label="Toggle password visibility"
                    >
                      <i className={`fa ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                    </span>
                  </div>
                  <small className="text-muted">Use at least 8 characters.</small>
                </div>

                <div className="mb-4">
                  <div className="input-group">
                    <span className="input-group-text" id={styles.inputGroupText}>
                      <i className="fa fa-check"></i>
                    </span>
                    <input
                      type={showConfirm ? 'text' : 'password'}
                      className="form-control"
                      placeholder="Confirm new password"
                      value={confirm}
                      onChange={(e) => setConfirm(e.target.value)}
                      required
                    />
                    <span
                      className="input-group-text"
                      id={styles.eye}
                      style={{ cursor: 'pointer' }}
                      onClick={() => setShowConfirm((s) => !s)}
                      aria-label="Toggle confirm password visibility"
                    >
                      <i className={`fa ${showConfirm ? 'fa-eye' : 'fa-eye-slash'}`} />
                    </span>
                  </div>
                </div>

                <div className="d-grid gap-2">
                  <button type="submit" className="btn btn-danger" disabled={submitting}>
                    <i className="fa fa-lock"></i>{' '}
                    {submitting ? 'Resetting...' : 'Reset password'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
